export default __webpack_public_path__ + "static/apache-kafka-eb1ec81847f079d68c0f04e46a555ef5.svg";